import React, { useEffect, useState } from 'react'
import { InitialType } from 'use-url-search-params'
import { Variant } from '../types/product'
import { User } from '../types/User'
import { WizardAction } from '../types/WigWizard'
import { removeWigStyle, saveWigStyle, updateWigStyle } from '../utils/metafieldService'
import { WigRemovalPopup } from './WigRemovalPopup'

export function SaveWigStyle({ className, user, searchParams, setSearchParams, selectedVariant, dispatch }: { className: string, user: User, searchParams: InitialType, setSearchParams: any, selectedVariant: Variant, dispatch: React.Dispatch<WizardAction> }) {
  const [styleToDelete, setStyleToDelete] = useState('');

  async function save() {
    if (!searchParams.styleId) {
      try {
        const styleId = await saveWigStyle({ user, sku: selectedVariant.sku, id: selectedVariant.id })
        setSearchParams({ styleId })
      } catch (error) {
        dispatch({ type: 'Error', value: 'You need to be signed in to save your tailored wig' })
        dispatch({ type: 'ErrorContext', value: 'Your five last creations will be stored under your Parfait account page.' })
      }
    } else if (user) {
      setStyleToDelete(searchParams.styleId as string)
    }
  }

  async function buttonAction() {
    await removeWigStyle({ user, id: styleToDelete })
    setSearchParams({ styleId: null })
    setStyleToDelete('')
  }

  useEffect(() => {
    if (searchParams.styleId && selectedVariant?.sku && selectedVariant?.id)
      updateWigStyle({
        styleId: searchParams.styleId as string,
        user,
        sku: selectedVariant.sku,
        id: selectedVariant.id
      }).catch(error => console.log('error: ', error))
  }, [searchParams, selectedVariant])

  return <a title={`${user.id ? 'Save this style to your profile' : 'Sign in to save this style to your profile'}`}>

    {styleToDelete &&
      <WigRemovalPopup user={user} id={styleToDelete} buttonAction={buttonAction} close={() => setStyleToDelete('')} />
    }

    <svg onClick={save} className={className} width="19" height="17" viewBox="0 0 19 17" fill={searchParams.styleId ? 'red' : 'transparent'} xmlns="http://www.w3.org/2000/svg">
      <path d="M9.61015 16.3004C9.57078 16.3296 9.53403 16.3568 9.50003 16.3819C9.46602 16.3568 9.42927 16.3296 9.3899 16.3004C9.13336 16.1099 8.76601 15.8322 8.32483 15.485C7.44174 14.7901 6.26634 13.8194 5.09286 12.7139C3.91705 11.6062 2.75575 10.3748 1.89197 9.15907C1.01715 7.92775 0.5 6.78449 0.5 5.8395C0.5 4.6329 0.948615 3.28197 1.76983 2.23984C2.58477 1.20567 3.74387 0.5 5.17786 0.5C6.62039 0.5 7.57479 1.15821 8.18129 1.82648C8.48692 2.16325 8.70218 2.50132 8.84054 2.75475C8.90947 2.881 8.95857 2.98489 8.9897 3.05521C9.00525 3.09034 9.01626 3.11696 9.02296 3.13367L9.0298 3.15106L9.03048 3.15283L9.03061 3.15317L9.03077 3.15362L9.03078 3.15365L9.03085 3.15382L9.49974 4.43789L9.96909 3.15398L9.96916 3.15382L9.96918 3.15376L9.96933 3.15334L9.96946 3.153L9.97014 3.15123L9.97699 3.13382C9.9837 3.11711 9.99472 3.09049 10.0103 3.05536C10.0414 2.98502 10.0906 2.88112 10.1596 2.75486C10.298 2.50141 10.5134 2.16332 10.8191 1.82652C11.4258 1.15817 12.3803 0.5 13.8221 0.5C15.2565 0.5 16.4156 1.20568 17.2304 2.23991C18.0515 3.2821 18.5 4.63326 18.5 5.84041C18.5 6.78555 17.9828 7.92884 17.108 9.16008C16.2443 10.3758 15.083 11.607 13.9072 12.7145C12.7337 13.8199 11.5583 14.7904 10.6752 15.4852C10.234 15.8323 9.86668 16.1099 9.61015 16.3004Z" stroke={searchParams.styleId ? 'red' : 'black'} />
    </svg>
  </a>
}
